import logOut from '@/assets/icon/logout.svg'
import dashboard from '@/assets/icon/dashboard.svg'
import reports from '@/assets/icon/reports.svg'
import settings from '@/assets/icon/settings.svg'
import organization from '@/assets/icon/organization.svg'
import plan from '@/assets/icon/plan.svg'

interface IconMapItem {
  text: string,
  iconRef: string
}

export const iconMap = {
  logOut: { text: 'Выйти', iconRef: logOut } as IconMapItem,
  dashboard: { text: 'Дашборд', iconRef: dashboard } as IconMapItem,
  reports: { text: 'Отчеты', iconRef: reports } as IconMapItem,
  settings: { text: 'Настройки', iconRef: settings } as IconMapItem,
  organization: { text: 'Организация', iconRef: organization } as IconMapItem,
  plans: { text: 'Тарифы', iconRef: plan } as IconMapItem
}

export const subjects = {
  departments: { text: 'Подразделения' },
  positions: { text: 'Должности' },
  persons: { text: 'Сотрудники' },
  organization: { text: 'Организация' },
  plans: { text: 'Тарифы' }
}
